export const SOCIAL_PROFILES_RESET_STATE = 'SOCIAL_PROFILES_RESET_STATE';
export const SOCIAL_PROFILES_CURRENT_ITEM = 'SOCIAL_PROFILES_CURRENT_ITEM';

export const SOCIAL_PROFILES_REQUEST_LOADING = 'SOCIAL_PROFILES_REQUEST_LOADING';
export const SOCIAL_PROFILES_REQUEST_SUCCESS = 'SOCIAL_PROFILES_REQUEST_SUCCESS';
export const SOCIAL_PROFILES_REQUEST_FAILED = 'SOCIAL_PROFILES_REQUEST_FAILED';

export const SOCIAL_PROFILES_CURRENT_ACTION = 'SOCIAL_PROFILES_CURRENT_ACTION';
export const SOCIAL_PROFILES_RESET_ACTION = 'SOCIAL_PROFILES_RESET_ACTION';